import { ConfigType, ConfigurationOutput, ListCommunityInfoQuery } from 'src/graphql';

import { TChildrenPayload } from 'src/components/ConfigurationManagementCentral';

export type TMapSidebarCommunitiesListProps = {
  className?: string;
  style?: React.CSSProperties;
};

export enum EDropdownMenuFilter {
  Simulations = 'SIMULATIONS',
  CanaryNetworks = 'CANARY_NETWORKS',
  Collaborations = 'COLLABORATIONS',
}

export enum EListFilter {
  All = 'ALL',
  MyCommunities = 'MY_COMMUNITIES',
  CanaryNetworks = 'CANARY_NETWORKS',
}

export type TListHeaderProps = {
  activeFilter: EListFilter;
  onFilterChange: (value: EListFilter) => void;
  searchQuery: string;
  onSearchQueryChange: (data: string) => void;
  isLoggedIn: boolean;
  activeDropdownFilter?: string;
};

export type TCommunitiesListProps = {
  height: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any[];
  removeCommunity: TChildrenPayload['handleCommunityRemove'];
  updatePersonalCommunitiesList: () => void;
  onDuplicationComplete: () => void;
  activeDropdownFilter?: EDropdownMenuFilter;
  setLoadingStatus?: (value: boolean) => void;
};

export type MapSidebarCommunitiesHeaderProps = {
  activeDropdownFilter: EDropdownMenuFilter;
  setActiveDropdownFilter: (val: EDropdownMenuFilter) => void;
};

export type TMapSidebarProjects = NonNullable<
  NonNullable<ListCommunityInfoQuery['listCommunityInfo']>
>;

export type TMapSidebarCanaryProjects = Array<
  Pick<
    ConfigurationOutput,
    'name' | 'uuid' | 'timestamp' | 'user' | 'private' | 'resultsStatus' | 'coordinates'
  > & { configType?: ConfigType }
>;
